(() => {
  if (window.customCardPriceModalInitialized) return;
  window.customCardPriceModalInitialized = true;

  const modalReturnFocusMap = new WeakMap();
  const ensureModalInBody = (modal) => {
    if (!modal) return;

    const existingModal = document.body.querySelector(`.custom-card-price-modal[id="${modal.id}"]`);
    if (existingModal && existingModal !== modal) {
      modal.remove();
      return;
    }

    if (modal.parentElement === document.body) return;
    document.body.appendChild(modal);
  };

  const prepareModals = () => {
    document.querySelectorAll('.custom-card-price-modal').forEach(ensureModalInBody);
  };

  const openModal = (modal, trigger) => {
    if (!modal) return;
    ensureModalInBody(modal);

    modal.removeAttribute('hidden');
    modalReturnFocusMap.set(modal, trigger || null);
    document.body.classList.add('custom-card-price-modal-open');

    const closeButton = modal.querySelector('.custom-card-price-modal__close');
    if (closeButton) closeButton.focus();
  };

  const closeModal = (modal) => {
    if (!modal || modal.hasAttribute('hidden')) return;

    modal.setAttribute('hidden', '');

    const opener = modalReturnFocusMap.get(modal);
    if (opener instanceof HTMLElement) {
      opener.focus();
    }

    if (!document.querySelector('.custom-card-price-modal:not([hidden])')) {
      document.body.classList.remove('custom-card-price-modal-open');
    }
  };

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-custom-card-price-open]');
    if (openTrigger) {
      const modalId = openTrigger.getAttribute('data-custom-card-price-open');
      const modal = document.getElementById(modalId);
      if (modal) {
        event.preventDefault();
        openModal(modal, openTrigger);
      }
      return;
    }

    const activeModal = document.querySelector('.custom-card-price-modal:not([hidden])');
    if (activeModal && !event.target.closest('.custom-card-price-modal__content')) {
      event.preventDefault();
      closeModal(activeModal);
      return;
    }

    const closeTrigger = event.target.closest('[data-custom-card-price-close]');
    if (closeTrigger) {
      const modal = closeTrigger.closest('.custom-card-price-modal');
      if (modal) {
        event.preventDefault();
        closeModal(modal);
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const modal = document.querySelector('.custom-card-price-modal:not([hidden])');
    if (!modal) return;

    event.preventDefault();
    closeModal(modal);
  });

  prepareModals();
  document.addEventListener('shopify:section:load', prepareModals);
})();
